module.exports = __webpack_public_path__ + "static/Vazir-f6b0854b99af25b683b1017431881340.woff2";